<template>
    <div id="login" class="dyy_f">
		<div class="ddy">
			<div class="dyy_hed">
				<img class="hed" :src='global.oss_website+"/pc/images/dyy_img/dyy_hed.png"' alt="">
				<div class="dzhed">
        		    <img src="https://xuexi.qsxueli.com/storage/images/pXVS7PVUvJt76b0meLZmf6o3PLJuYGl1k6SxsRE3.png" alt="">
        		    <div class="hed_txt">
        		        专业技术人员继续教育网络平台
        		    </div>
        		</div>
				<div class="menu">
        		    <span :class="page=='index'?'sele':''" @click="page='index'"><svg class="iconfontSymbol" aria-hidden="true"><use xlink:href="#icona-Group789"></use></svg>首页</span>
        		    <span :class="page=='coursesele'?'sele':''" @click="page='coursesele'"><svg class="iconfontSymbol" aria-hidden="true"><use xlink:href="#iconzhengli"></use></svg>课程中心</span>
        		    <span :class="page=='announcement'?'sele':''" @click="page='announcement'"><svg class="iconfontSymbol" aria-hidden="true"><use xlink:href="#icona-Group808"></use></svg>通知公告</span>
					<span :class="page=='charging_standards'?'sele':''" @click="page='charging_standards'"><svg class="iconfontSymbol" aria-hidden="true"><use xlink:href="#icona-Group797"></use></svg>收费标准</span>
        		    <!-- <span>关于我们</span> -->
        		</div>
			</div>
			<div class="dyy_con" :style="page=='announcement'?'padding: 0;':''">
        		<div class="menu_bar" v-show="page=='index'">
        		    <div class="menu_trends">
        		        <div class="trends">
        		            <div class="trends_hed">
								<svg class="iconfontSymbol" aria-hidden="true"><use xlink:href="#icona-Group808"></use></svg>
								<span>通知公告</span>
								<div class="tail_decoration">
									<div class="overturn_div"></div>
									<div class="overturn_div min"></div>
									<div class="tail"></div>
								</div>
								
							</div>
        		            <div class="trends_list">
        		                <div class="trends_con" v-for="(item,i) in index_news_list" :key="i" @click="trends_con_ckick(item.id)">
									<div class="img">
										<img :src="item.cover?global.oss_link +item.cover:''">
									</div>

        		                    <div class="trends_txt">
        		                        <div class="yuan">{{item.title}}</div>
        		                        <div class="sub_title">{{item.sub_title}}</div>
        		                        <div class="time">{{item.release_time}}</div>
										<img class="blue_line" :src='global.oss_website+"/pc/images/dyy_img/blue_line.png"' alt="">
        		                    </div>
        		                </div>
        		            </div>
        		        </div>
        		    </div>
					<div class="trends">
						<div class="trends_hed" v-if="!(login_text=='register')||login_b">
							<svg class="iconfontSymbol" aria-hidden="true"><use xlink:href="#icona-Group798"></use></svg>
							<span>登录/注册</span>
							<div class="tail_decoration">
								<div class="overturn_div"></div>
								<div class="overturn_div min"></div>
								<div class="tail"></div>
							</div>
							
						</div>
						<div class="loginBox" :class="login_b?'gradient':''" :style="!login_b?(login_text=='forget'?'height: 400px;':'height: 457px;'):''">
        		    	    <div class="loginConBox" v-loading="loginload">
							    <div class="loginCon forget_register" v-if="!login_b" style="margin-top: -30px;" :class="login_text=='register'?'register':''">
							    	<!-- <h3 style="margin:0;font-size: 28px;">
										{{login_text=='forget'?'忘记密码':'注册账号'}}</h3> -->
						    		<el-form  style="margin-top: 10px;" :model="passwordForm" :rules="passwordrules" ref="passwordForm" autocomplete="new-password" @keyup.enter.native="change_password()" class="acc_login_con">
						    			<el-form-item class="lineInput" prop="mobile">
						    				<span>手机号</span>
						    				<el-input v-model.trim="passwordForm.mobile" type="number" name="mobile" id="mobile" placeholder="手机号"></el-input>
						    			</el-form-item>
						    			<el-form-item class="lineInput df" prop="image_captcha" >
						    				<span>图形验证码</span>
						    				<el-input v-model="passwordForm.image_captcha" type="text" name="image_captcha" id="image_captcha" placeholder="图形验证码"></el-input>
						    				<img :src="captcha_img.img" class="image_captcha" alt="" @click="verification_code">
						    			</el-form-item>
						    			<el-form-item class="lineInput df" prop="captcha">
						    				<span>短信验证码</span>
						    				<el-input v-model="passwordForm.captcha" type="text" name="captcha" id="captcha" placeholder="短信验证码" autocomplete="off"></el-input>
						    				<el-button type="primary" @click="getCaptcha" v-if="count_down==0">获取验证码</el-button>
						    				<div v-else style="color: #177fd6;">{{count_down}}</div>
						    			</el-form-item>

										<el-form-item class="lineInput" prop="name" v-if="login_text=='register'">
						    				<span>姓名</span>
						    				<el-input v-model.trim="passwordForm.name" type="text" name="name" id="name" placeholder="姓名"></el-input>
						    			</el-form-item>
										<el-form-item class="lineInput" prop="idcard" v-if="login_text=='register'">
						    				<span>身份证</span>
						    				<el-input v-model.trim="passwordForm.idcard" type="text" name="idcard" id="idcard" placeholder="身份证"></el-input>
						    			</el-form-item>


						    			<el-form-item class="lineInput df" prop="new_password">
						    				<span>新密码</span>
						    				<el-input v-model.trim="passwordForm.new_password" show-password type="password" name="new_password" id="new_password" placeholder="新密码" autocomplete="new-password"></el-input>
						    			</el-form-item>
						    			<el-form-item class="lineInput df" prop="confirm" style="margin-bottom: 10px;">
						    				<span>确认密码</span>
						    				<el-input v-model.trim="passwordForm.confirm" type="text" show-password name="confirm" id="confirm" placeholder="确认密码" autocomplete="new-password"
											 @paste.native.capture.prevent="false"></el-input>
						    			</el-form-item>
						    			<div class="ctrlBtn" >
						    				<a href="#" @click="login_b=true">返回登录</a>
						    			</div>
						    			<el-button type="primary" class="btn loginBtn" style="margin-top:10px;" @click="change_password()">提交</el-button>
						    		</el-form>
						    	</div>
						    	<div class="loginCon" v-show="login_b">
									<h2 class="h2">欢迎登录</h2>
						    		<!-- <ul class="login_port">
						    			<li v-for="(item, index) in port" :key="index"
						    			 :class="{act: port_computed(item.link)}">{{item.text}}</li>
						    		</ul> -->
						    		<!-- <ul class="fashion">
						    			<li v-for="(item,key,index) in fashion" :key='index' :class="index == login_fashion?key+' act':key" @click="login_fashion = index">
						    				<i class="iconfont" v-html='item.icon'></i>{{item.text}}
						    			</li>
						    		</ul> -->
						    		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" autocomplete="auto" @keyup.enter.native="login('ruleForm')" v-show="login_fashion == 0" class="acc_login_con">
						    			<el-form-item class="lineInput" prop="name">
						    				<span>身份证</span>
						    				<el-input v-model="ruleForm.name" type="text" name="uname" id="uname" placeholder="身份证"></el-input>
						    			</el-form-item>
						    			<el-form-item class="lineInput" prop="pwd"  style="margin-bottom: 10px;">
						    				<span>密码</span>
						    				<el-input v-model="ruleForm.pwd" type="password" show-password name="upwd" id="upwd" placeholder="密码"></el-input>
						    				<!-- <p class="pasBtn show iconfont">&#xe67f;</p> -->
						    			</el-form-item>
						    			<div class="ctrlBtn" >
						    				<a href="#" @click="forgot_password">忘记密码</a>
						    			</div>
						    			<el-button type="primary" class="btn loginBtn half" @click="login('ruleForm')">登录</el-button>
						    			<el-button type="primary" class="btn videoBtn half" @click="forget_register">注册账号</el-button>
						    		</el-form>
						    		<div v-show="login_fashion == 1" class="qrcode_login_con">
						    			<div id="login_container" v-show="wechat_step == 0"></div>
						    			<el-form v-show="wechat_step == 1" :model="wechatForm" :rules="rules" ref="wechatForm" autocomplete="auto" @keyup.enter.native="login('wechatForm')" class="wechat_login_con">
						    				<div class="authHead">
						    					<!-- <div class="backBox">
						    						<p class="back_tit">登录绑定</p>
						    					</div> -->
						    					<p class="authDesc">请输入您的登录账号登录</p>
						    				</div>
						    				<el-form-item class="lineInput" prop="name">
						    					<span>身份证</span>
						    					<el-input v-model="wechatForm.name" type="text" name="wxname" id="wxname" placeholder="身份证"></el-input>
						    				</el-form-item>
						    				<el-form-item class="lineInput" prop="pwd">
						    					<span>密码</span>
						    					<el-input v-model="wechatForm.pwd" type="password" show-password name="wxpwd" id="wxpwd" placeholder="密码"></el-input>
						    				</el-form-item>
						    				<el-button type="primary" class="btn loginBtn" @click="login('wechatForm')">登录</el-button>
						    			</el-form>
						    		</div>
						    	</div>
						    </div>
        		    	</div>
					</div>
        		    
        		</div>
				<div class="course_list" v-show="page=='index'">
					<div class="course_list_hed">
						<div class="hed">
							<div class="trends_hed" v-if="!(login_text=='register')||login_b">
								<svg class="iconfontSymbol" aria-hidden="true"><use xlink:href="#iconpaidui"></use></svg>
								<span>推荐专业</span>
								<div class="tail_decoration">
									<div class="overturn_div"></div>
									<div class="overturn_div min"></div>
									<div class="tail"></div>
								</div>

							</div>
						</div>
						<div class="more" @click="page='coursesele'">查看更多 >>></div>
					</div>
					<div class="course_list_con">
						<div class="course" v-for="(item,i) in recommend_course" :key="i">
							<div class="img" v-if="item.cover">
								<img :src="item.cover?global.oss_link +item.cover:''">
							</div>
							<div v-else class="imitate_cover">
								<span>{{item.mould_name}}</span>
							</div>
							<p>{{item.mould_name}}</p>
						</div>
					</div>
				</div>
			</div>
			<coursesele v-if="page=='coursesele'" style="margin-top: 20px;"></coursesele>
			<div v-if="page=='announcement'">
				<announcement :switch_jump="true"></announcement>
			</div>
			<guidetextassembly v-if="page=='guidetextassembly'" :news_id="news_id" :not_login="true"></guidetextassembly>
			<guidetextassembly v-if="page=='charging_standards'" :code='code' :not_login="true"></guidetextassembly>
			
		</div>
		
    </div>
</template>

<script>
import coursesele from '@/components/dyy_assembly/courseSele.vue'
import announcement from '@/components/dyy_assembly/announcement.vue'
import guidetextassembly from '@/components/dyy_assembly/guideTextAssembly.vue'
export default {
    name: 'ddy'
	,components:{
        coursesele,
		announcement,
		guidetextassembly
    }
	,data () {
        var validatePass = (rule, value, callback) => {
			let pwdReg = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8}');
        	if (value === '' || value === undefined) {
        	  callback(new Error('请输入密码'));
        	} else if(!pwdReg.test(value)){
				callback(new Error('密码至少包含字母、数字、特殊字符各1位,总长度8位及以上!'));
			} else {
        	  callback();
        	}
		}
		var validatePass2 = (rule, value, callback) => {
        	if (!value) {
        	  callback(new Error('请再次输入密码'));
        	} else if (value !== this.passwordForm.new_password) {
        	  callback(new Error('两次输入密码不一致!'));
        	} else {
        	  callback();
        	}
		}
		return {
            loginload:false,
			login_b:true,
            passwordForm:{//重置密码
				mobile:'',
				image_captcha:''
			},
            ruleForm: {
				name:'',
				pwd:'',
			},
            wechatForm: {
				name:'',
				pwd:'',
			},
            port:[{
				link:'web',
				text:'学生登录',
			}],
            wechat_step:0,
			news_id:'',
            fashion:{
				acc:{
					icon:'&#xe683;',
					text:'账号登录',
				} 
				// ,wechat:{
				// 	icon:'&#xe607;',
				// 	text:'微信登录',
				// } 
			},
			login_fashion:0,
            //发送短信倒计时
			count_down:0,
            rules: {
				//required：是否必填，message错误提示内容，trigger触发方式
				name: [
					{ required: true, message: '请输入身份证', trigger: 'blur' },
				],
				pwd: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
				],
			},
            captcha_img:{
		    	image_captcha:''
		    },
            //忘记密码操作校验
            passwordrules:{
				mobile: [
					{ required: true, message: '请输入11位的手机号', trigger: 'blur' },
					{ min: 11, max:11, message: '请输入11位的手机号', trigger: 'blur' }
				],
				captcha: [
					{ required: true, message: '请输入短信验证码', trigger: 'blur' },
				],
				name: [
					{ required: true, message: '请输入姓名', trigger: 'blur' },
				],
				idcard: [
					{ required: true, message: '请输入身份证', trigger: 'blur' },
				],
				new_password: [
					{ validator: validatePass, trigger: 'blur' },
				],
				confirm: [
					{ validator: validatePass2, trigger: 'blur' },
				],
				// image_captcha: [
				// 	{ required: true, message: '请输入验证码', trigger: 'blur' },
				// ],
			},
			login_text: 'forget', // register注册  forget忘记密码
			index_news_list:[],
			recommend_course:[],
			page:'index', 
			code:'payment.guide'
        }
    }
    ,mounted:function(){
		let that = this
			,src
		this.$ajax.get(
			this.global.serverSrc + this.global.qianzui + '/news/index_news_list?limit=3'
		)
		.then(function (res){
			let resData = res.data
			if(resData.code==0){
				that.index_news_list = resData.data.data
				// console.log(res);
				// console.log(that.index_news_list);
			}else{	

			}
		})
		var token=this.$cookies.get("token");
		if(token){
			this.$store.dispatch('get_identity_list').then(res=>{
				if (res.length>=1) {
					this.$router.push("/web/"+this.$store.state.defaultIndex);
				}else{
					this.$router.push("/web/course_selection?page=course_selection");
					window.location.reload()
				}
			})
			
		}

		this.$ajax.get(
			this.global.serverSrc + this.global.qianzui + '/course/recommend_course?limit=4'
		)
		.then(function (res){
			let resData = res.data
			if(resData.code==0){
				that.recommend_course = resData.data.data
			}else{	

			}
		})
			
		if(process.env.NODE_ENV == 'development'){
			src = window.location.origin+'/#/web/login/'
		}else{
			src = window.location.origin+'/web/#/web/login/'
		}
		// console.log(escape(src));
		new WxLogin({
			id:"login_container",//div的id
			appid: "wx102350877e4d11b8",
			scope: "snsapi_login",//写死
			redirect_uri:escape(src),
			state: "123",
			style: "black",//二维码黑白风格        
			href: 'https://xuexi.qsxueli.com/web/qrcode.css'
		});
		// 设置页面标题
		document.title = '首页 - 电子科技大学广东信息工程研究院 - 专业技术人员继续教育网络平台'
	}
    ,methods:{
        login(formName){
			let that=this
				,link = '/login/password'
				
			if(formName == 'ruleForm'){
				link = '/login/password'
			}else if(formName == 'wechatForm'){
				link = '/login/wechat_bind'
			}
			this.$refs[formName].validate((valid) => {
				if (valid) {
					const url = this.global.serverSrc+this.global.qianzui+link;
					this.loginload = true
					let logininfo = {
						mobile:that[formName].name
						,password:that[formName].pwd
						,captcha:'-'
					}
					//判断是否有绑定微信ID
					if(that.wechat_login_id){
						logininfo.id = that.wechat_login_id
					}
					this.$ajax.post(
						url
						,this.$qs.stringify(logininfo)
						// ,{headers: {
						// 	'Content-Type': 'application/json',
						// 	// auth: '123'
						// }}
					)
					.then((res)=>{
						that.loginload = false
						res=res.data;
						if(res.ok){
							let data=res.data
							// that.global.token="Bearer "+data.token	//保存token
							that.$cookies.set("token", "Bearer "+data.token, 0)

							// 设置请求头token
							// that.$ajax.defaults.headers.common['Authorization'] = "Bearer "+data.token

							that.$emit("swmuban",true);		//修改app.vue 的 muban_bol 值
							// localStorage.message_popup = true		// 开启新消息提醒
							// localStorage.max_term_popup = true		// 开启超前课程提醒
							// window.location.href = window.location.origin
							this.$store.dispatch('get_identity_list').then(res=>{
								if (res.length>=1) {
									that.$router.push("/web/" + this.$store.state.defaultIndex);
								}else{
									that.$router.push("/web/course_selection?page=course_selection");
									window.location.reload()
								}
							})
							
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
			// let margin=document.body.clientHeight-$(".loginBox").height();
			// $("#login").css("padding-top",margin/2)
		}
        ,port_computed(link){
			return window.location.pathname.indexOf(link) > -1
		}
		,return_fn(){
			this.page = 'index'
        }
		,trends_con_ckick(id){
			this.news_id = id
			this.page = 'guidetextassembly'
		}
		//触发微信登录
		,wechat_login(){
			let that = this
			this.loginload = true
			this.login_fashion = 1
			this.$ajax.get(
				this.global.serverSrc + this.global.qianzui + '/login/wechat_login',{
					params:{
						code:this.$selfjs.getParamString("code")
					}
				}
			)
			.then(function (res){
				let resData = res.data
				that.loginload = false
				if(resData.code==0){
					let data=resData.data
					// that.global.token="Bearer "+data.token	//保存token
					that.$cookies.set("token", "Bearer "+data.token, 0)

					// 设置请求头token
					// that.$ajax.defaults.headers.common['Authorization'] = "Bearer "+data.token

					that.$emit("swmuban",true);		//修改app.vue 的 muban_bol 值
					that.$router.push("/web/" + this.$store.state.defaultIndex);
					localStorage.message_popup = true		// 开启新消息提醒
				}else if(resData.code==2){			//返回2则需要绑定账号
					that.wechat_step = 1		//跳转到微信绑定
					that.wechat_login_id = resData.data.id
				}
			})
		},
        //请求图形验证码
		async verification_code(){
			if (!this.operating) {
				let that = this
				this.operating = true
				const url = this.global.serverSrc+this.global.qianzui+'/captcha/image';
				await this.$ajax.get(
					url
				)
				.then((res)=>{
					that.captcha_img = res.data.data
					that.operating = false
				})
				.catch(function (res){
					that.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~')
				});
			}
		}
        //忘记密码
		,forgot_password(){
			this.login_b = false
			this.login_text = 'forget'
			this.verification_code()
		}
        //获取验证码
		,getCaptcha(){
			if (!this.passwordForm.mobile) {
				this.$message.error('请输入手机号');
				return false
			}else if(!this.passwordForm.image_captcha) {
				this.$message.error('请输入图形验证码');
				return false
			}
			let that = this
			let url = this.global.serverSrc+this.global.qianzui+'/captcha/sms';
			let data = {
				mobile:this.passwordForm.mobile,
				image_captcha:this.passwordForm.image_captcha,
				scene:this.login_text=='register'?'register':'password_reset',
				image_key:this.captcha_img.key,
			}
			this.short_message = true
			const loading = this.$loading({
        	  	lock: true,
        	  	text: 'Loading',
        	  	spinner: 'el-icon-loading',
        	  	background: 'rgba(0, 0, 0, 0.7)'
        	});
			this.$ajax.post(
				url,
				this.$qs.stringify(data)
			).then((res)=>{
				loading.close()
				if (res.data.code==0) {
					that.count_down = 60
					let int = setInterval(function(){
						that.count_down--
						if (that.count_down==0) {
							window.clearInterval(int)
						}
						
					},1000)
					// that.success('发送成功')
					that.$message({
        				message: '发送成功',
        				type: 'success'
        			});
				}else{
					that.verification_code()
				}
			}).catch(_ => {
				that.verification_code()
				// console.log(_);
				loading.close()
				that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~');
			});
		}
        //修改密码
		,change_password(){
			this.$refs.passwordForm.validate((valid) => {
				// console.log(valid);
				if (valid) {
					const url = this.global.serverSrc+this.global.qianzui+(this.login_text=='forget'? '/password/resetPassword':'/register');
					this.loginload = true
					let that = this
					let logininfo = {
						mobile:that.passwordForm.mobile
						,password:that.passwordForm.new_password
						,captcha:that.passwordForm.captcha
					}
					if (this.login_text=='register') {
						logininfo.name = that.passwordForm.name
						logininfo.idcard = that.passwordForm.idcard
					}
					this.$ajax.post(
						url
						,this.$qs.stringify(logininfo)
					)
					.then((res)=>{
						that.loginload = false
						// console.log(res);
						if(res.data.code==0){
							that.$message.success('修改成功！即将跳转到登录界面！')
							window.setTimeout(function(){
								that.login_b = true
								that.passwordForm = {
									mobile:'',
									image_captcha:'',
									captcha:'',
									new_password:'',
									confirm:''
								}
							},2000)
						}
					})
				}
				

			});
		}
		//注册
		,forget_register(){
			this.login_b = false
			this.login_text = 'register'
			this.verification_code()
		}
    }
}
</script>

<style scoped>
    div.loginBox{
        width: auto;
        position: static;
        height: auto;
        margin: 0;
        padding: 20px 80px;
        box-shadow: 0 0px 24px -10px rgba(0,0,0,0.4);
    }
	div.loginBox .loginCon.register .lineInput{
		margin-bottom: 16px;
	}
    div.loginBox .loginConBox{
        margin-top: 0;
    }
	#login{
    	box-sizing: border-box;
	}
        
</style>



// WEBPACK FOOTER //
// src/components/login_com/ddy.vue